import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

import { ImageDto } from '@/lib/image.dto';

export function useLocationImageOrPlaceholderCollection(
  images: ImageDto[],
  minSize = 3
) {
  const t = useTranslations('general.image-placeholders');

  const getImagePlaceholder = (number: number): ImageDto => ({
    url: `/public-s3/images/location-placeholders/placeholder_${number}.webp`,
    altText: t(`${number}.alt`),
    caption: null,
    order: number,
  });

  const getCollectionCompleted = () => {
    const collection = [...images];

    while (collection.length < minSize) {
      collection.push(getImagePlaceholder(collection.length + 1));
    }

    return collection;
  };

  const [collection, setCollection] = useState<ImageDto[]>(
    getCollectionCompleted()
  );

  useEffect(() => {
    setCollection(getCollectionCompleted());
  }, [images]);

  return collection;
}
